import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cross-icon',
  templateUrl: './cross-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CrossIconComponent {}
